<template>
  <Card
    :card-class-names="cardClassNames"
    :has-body-padding-small="true"
  >
    <template #header>
      <h2 class="section-title heading-color">
        Daily Snow Forecast
      </h2>
    </template>
    <template #body>
      <div :class="$style.header">
        <img
          class="tw-block tw-rounded-md tw-border-1 border-color"
          :src="authorPhotoUrl"
        >
        <div>
          <h3 class="md:tw-mb-1 section-title heading-color">
            {{ dailySnowName }}
          </h3>
          <div>
            <span
              :class="[
                'tw-mr-1',
                postPostedAtClassName,
              ]"
            >
              {{ postPostedAtText }}
            </span>
            <span class="tw-text-sn tw-font-normal">
              {{ authorName }}
            </span>
          </div>
        </div>
      </div>
      <p :class="postSummaryClass">
        {{ postSummary }}
      </p>
      <NuxtLink
        class="tw-font-medium link-color-brand"
        :to="postUrl"
      >
        Read More
      </NuxtLink>
    </template>
  </Card>
</template>

<script>
import DailySnowMixin from './DailySnowMixin';

export default {
  name: 'LocationDailySnowSummaryCard',

  mixins: [
    DailySnowMixin,
  ],

  props: {
    cardClassNames: {
      type: String,
      default: null,
    },
  },

  computed: {
    postSummaryClass() {
      return `tw-font-normal tw-my-4 ${this.$style.postSummary}`;
    },
  },
};
</script>

<style module>
.header {
  column-gap: 0.625rem;
  display: grid;
  grid-template-columns: 3rem 1fr;
}

/**
 * @todo Use the tailwindcss-line-clamp plug-in if these styles are used elsewhere.
 * @see https://github.com/tailwindlabs/tailwindcss-line-clamp
 */
.postSummary {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
